import BossModel from "@/models/BossModel";
import User from '@/models/User/User';
import Country from '@/models/Country/Country';

export default class CountryProficiency extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'user/country-proficiency';

    /**
     *
     * @type {string}
     */
    static entity = 'countryProficiencies';

    static fields() {
        return {
            id: this.number(null),
            user_id: this.number(null),
            country_id: this.number(null),
            proficiency_cid: this.number(null),
            created_at: this.attr(null),
            updated_at: this.attr(null),
            user: this.belongsTo(User, 'user_id'),
            country: this.belongsTo(Country, 'country_id'),
        }
    }

    /**
     *
     * @param params
     * @returns {Promise<TResult>}
     */
    static get(params = {}) {
        return this.api()
            .filtered(params.filters)
            .paginator(params.paginator)
            .with(['user', 'country'])
            .ordered(params.sortBy)
            .get();
    }
}
